export default __webpack_public_path__ + "static/media/matcap2-optimised.1729cc0d.png";